module.exports = function(notifications) {
	'use strict'
	notifications.directive('notificationSettingsDir',notificationSettingsDir);
	notificationSettingsDir.$inject=[];
	function notificationSettingsDir() {
		return {
			template: require('./partial/notificationSettings.html'),
			controller:'notificationSettingsController',
			controllerAs:'vmns',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/notificationsModule/notificationsettings/js/directive/notificationSettingsDirective.js
// module id = 533
// module chunks = 0